export default (store) => {
  store.subscribe((mutation) => {
    if (['setPage', 'setPerPage'].includes(mutation.type)) {
      store.dispatch('fetchLogsFromApi');
    }
  });
};
